import React from "react";
import { CashFlowStatementResponse } from "@common/types/reports/types";
import { Entity } from "@common/types/entity";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { Card } from "@design-system/Card/Card";
import { CardSection } from "@design-system/Card/CardSection";
import { GlTableCallbacks } from "../glDrillDown.lib";
import { AccountingReportFilters } from "../types";
import { AccountingReportHeader } from "../AccountingReportHeader";
import { AccountingReportFooter } from "../AccountingReportFooter";
import {
    AccountingReportContext,
    useAccountingReportContextValue,
} from "../AccountingReport.context";
import { useReportChrome } from "../useReportChrome";
import { CashFlowStatementTable } from "./CashFlowStatementTable";
import styles from "./CashFlowStatementContent.module.scss";

interface Props {
    report: CashFlowStatementResponse;
    filters: AccountingReportFilters;
    chrome: ReportPresentationChrome;
    numberFormat: NumberFormatValues;
    generationDate: Date;
    entity: Entity;
    onDrillDown: GlTableCallbacks["onDrillDown"];
}

export const CashFlowStatementContent: React.FC<Props> = ({
    report,
    filters,
    chrome,
    numberFormat,
    generationDate,
    entity,
    onDrillDown,
}) => {
    const resolvedChrome = useReportChrome({
        chrome,
        generationDate,
    });
    const accountingReportContextValue = useAccountingReportContextValue(
        filters,
        numberFormat,
    );

    if (!entity) {
        return null;
    }

    return (
        <Card stacked className={styles.content} sharpEdges fullPage>
            <AccountingReportContext.Provider
                value={accountingReportContextValue}
            >
                <CardSection>
                    <AccountingReportHeader chrome={resolvedChrome} />
                </CardSection>
                <CashFlowStatementTable
                    report={report}
                    onDrillDown={onDrillDown}
                />
                <AccountingReportFooter chrome={resolvedChrome} />
            </AccountingReportContext.Provider>
        </Card>
    );
};
